import { gql } from "@apollo/client";

type StatsData = {
    smsCount: number;
    callCount: number;
    emailCount: number;
    customCount: number;
    reminderCount: number;
    voicemailCount: number;
    targetSms: number;
    targetCall: number;
    targetEmail: number;
};

type ActivityBreakdown = {
    activityName: string;
    duration: number;
};

type AgentMetrics = {
    totalConversations?: number;
    totalTransfers?: number;
    transferRate?: number;
};

type AuthenticatedUser = {
    agentActivityBreakdown: ActivityBreakdown[];
    metrics?: AgentMetrics | null;
};

export type GetAgentStatsState = {
    getDailyStats: StatsData;
    getAuthenticatedUser: AuthenticatedUser;
};

export const GET_AGENT_TASK_STATS = gql`
    query {
        getDailyStats {
            smsCount
            callCount
            customCount
            targetSms
            targetCall
            emailCount
            targetEmail
            reminderCount
            voicemailCount
        }
        getAuthenticatedUser {
            agentActivityBreakdown {
                activityName
                duration
            }
            metrics {
                totalConversations
                totalTransfers
                transferRate
            }
        }
    }
`;
